

// import { useCallback, useEffect, useState } from "react";

// /* =====================================================
//    API  (backend: /api/palaces  -> palaceRoutes.js)
// ===================================================== */

// const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
// const API = `${API_BASE}/api/palaces`;

// async function request(url, options = {}) {
//   const token = localStorage.getItem("vendorToken");

//   if (!token) {
//     window.location.href = "/vendor-login";
//     throw new Error("Session expired. Please login again.");
//   }

//   const response = await fetch(url, {
//     ...options,
//     headers: { Authorization: `Bearer ${token}`, ...(options.headers || {}) },
//   });

//   const data = await response.json().catch(() => ({}));

//   if (response.status === 401) {
//     localStorage.removeItem("vendorToken");
//     localStorage.removeItem("vendorUser");
//     window.location.href = "/vendor-login";
//     throw new Error("Session expired. Please login again.");
//   }

//   if (!response.ok || data.success === false) {
//     throw new Error(data.message || `Request failed (${response.status})`);
//   }

//   return data;
// }

// /* =====================================================
//    OPTIONS / DEFAULTS
// ===================================================== */

// const PROPERTY_TYPES = [
//   ["heritage-palace", "Heritage Palace"],
//   ["luxury-palace", "Luxury Palace"],
//   ["royal-palace", "Royal Palace"],
//   ["heritage-hotel", "Heritage Hotel"],
//   ["fort-palace", "Fort Palace"],
//   ["other", "Other"],
// ];

// const AMENITY_OPTIONS = [
//   "Free Wi-Fi", "Parking", "Air Conditioning", "Restaurant", "Room Service",
//   "Swimming Pool", "Spa", "Gym", "Airport Transfer", "24x7 Front Desk",
//   "Power Backup", "Lift / Elevator", "Laundry", "Banquet Hall", "Garden / Lawn",
//   "Heritage Tour", "Cultural Shows", "Wheelchair Accessible",
// ];

// // No approval flow: a palace is either Live or Inactive
// const STATUS_STYLE = {
//   APPROVED: ["Live", "#166534", "#dcfce7"],
//   INACTIVE: ["Inactive", "#334155", "#f1f5f9"],
// };

// const MAX_IMAGES = 30;
// const MAX_IMAGE_MB = 10;

// const EMPTY_FORM = {
//   propertyName: "",
//   propertyType: "heritage-palace",
//   shortDescription: "",
//   description: "",
//   starRating: "3",

//   phone: "",
//   alternatePhone: "",
//   email: "",

//   addressLine: "",
//   landmark: "",
//   city: "",
//   state: "",
//   country: "India",
//   pincode: "",
//   latitude: "",
//   longitude: "",

//   totalRooms: "0",
//   heritageCertified: false,
//   weddingAllowed: false,
//   eventAllowed: false,

//   checkInTime: "14:00",
//   checkOutTime: "11:00",

//   amenities: [],

//   policies: {
//     cancellationPolicy: "",
//     childPolicy: "",
//     petPolicy: "",
//     smokingPolicy: "",
//     unmarriedCouplesAllowed: false,
//     localIdAllowed: false,
//     idProofRequired: true,
//   },
// };

// const str = (v) => (v === undefined || v === null ? "" : String(v));

// function formFromPalace(p) {
//   return {
//     propertyName: str(p.propertyName),
//     propertyType: p.propertyType || "heritage-palace",
//     shortDescription: str(p.shortDescription),
//     description: str(p.description),
//     starRating: str(p.starRating ?? 3),

//     phone: str(p.contact?.phone),
//     alternatePhone: str(p.contact?.alternatePhone),
//     email: str(p.contact?.email),

//     addressLine: str(p.address?.addressLine),
//     landmark: str(p.address?.landmark),
//     city: str(p.address?.city),
//     state: str(p.address?.state),
//     country: str(p.address?.country || "India"),
//     pincode: str(p.address?.pincode),
//     latitude: str(p.address?.latitude),
//     longitude: str(p.address?.longitude),

//     totalRooms: str(p.totalRooms ?? 0),
//     heritageCertified: Boolean(p.heritageCertified),
//     weddingAllowed: Boolean(p.weddingAllowed),
//     eventAllowed: Boolean(p.eventAllowed),

//     checkInTime: p.checkInTime || "14:00",
//     checkOutTime: p.checkOutTime || "11:00",

//     amenities: Array.isArray(p.amenities) ? p.amenities : [],

//     policies: {
//       ...EMPTY_FORM.policies,
//       ...(p.policies || {}),
//     },
//   };
// }

// /* =====================================================
//    VALIDATION  (same rules as palaceModel.js)
// ===================================================== */

// function validateForm(form, imageCount) {
//   const name = form.propertyName.trim();

//   if (!name) return "Property name is required.";
//   if (name.length < 2) return "Property name must be at least 2 characters.";

//   const star = Number(form.starRating);
//   if (!Number.isFinite(star) || star < 1 || star > 5) {
//     return "Star rating must be between 1 and 5.";
//   }

//   if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
//     return "Please enter a valid contact email.";
//   }

//   const rooms = Number(form.totalRooms || 0);
//   if (!Number.isInteger(rooms) || rooms < 0) {
//     return "Total rooms must be a whole number (0 or more).";
//   }

//   if (form.latitude !== "") {
//     const lat = Number(form.latitude);
//     if (!Number.isFinite(lat) || lat < -90 || lat > 90) {
//       return "Latitude must be between -90 and 90.";
//     }
//   }

//   if (form.longitude !== "") {
//     const lng = Number(form.longitude);
//     if (!Number.isFinite(lng) || lng < -180 || lng > 180) {
//       return "Longitude must be between -180 and 180.";
//     }
//   }

//   if (!form.checkInTime || !form.checkOutTime) {
//     return "Check-in and check-out time are required.";
//   }

//   const lower = form.amenities.map((a) => a.trim().toLowerCase());
//   if (lower.some((a) => !a) || new Set(lower).size !== lower.length) {
//     return "Amenities cannot be empty or duplicated.";
//   }

//   if (imageCount > MAX_IMAGES) {
//     return `A maximum of ${MAX_IMAGES} images is allowed.`;
//   }

//   return "";
// }

// /* =====================================================
//    STYLES (scoped with "pl-" prefix)
// ===================================================== */

// const css = `
// .pl-wrap{font-family:'Inter','Segoe UI',Arial,sans-serif;color:#0f172a}
// .pl-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:22px}
// .pl-head h2{margin:0 0 4px;font-size:26px;letter-spacing:-.5px}
// .pl-head p{margin:0;color:#64748b;font-size:14px}
// .pl-btn{border:0;border-radius:10px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;transition:.15s}
// .pl-btn:disabled{opacity:.6;cursor:not-allowed}
// .pl-primary{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff}
// .pl-ghost{background:#fff;border:1px solid #cbd5e1;color:#0f172a}
// .pl-danger{background:#fff;border:1px solid #fecaca;color:#b91c1c}
// .pl-small{padding:7px 12px;font-size:12px}
// .pl-alert{padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px}
// .pl-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
// .pl-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
// .pl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}
// .pl-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;overflow:hidden;display:flex;flex-direction:column}
// .pl-cover{height:170px;background:#f1f5f9;display:grid;place-items:center;color:#94a3b8;font-size:13px;position:relative}
// .pl-cover img{width:100%;height:100%;object-fit:cover;display:block}
// .pl-badge{position:absolute;top:10px;left:10px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:800}
// .pl-body{padding:16px;display:flex;flex-direction:column;gap:6px;flex:1}
// .pl-body h3{margin:0;font-size:17px}
// .pl-meta{font-size:12px;color:#64748b}
// .pl-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:auto;padding-top:12px}
// .pl-empty{background:#fff;border:1px dashed #cbd5e1;border-radius:16px;padding:48px 20px;text-align:center;color:#64748b}
// .pl-form{display:flex;flex-direction:column;gap:18px}
// .pl-section{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:20px}
// .pl-section h3{margin:0 0 14px;font-size:16px}
// .pl-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
// .pl-field{display:flex;flex-direction:column;gap:6px}
// .pl-field.full{grid-column:1/-1}
// .pl-field label{font-size:12px;font-weight:700;color:#374151}
// .pl-field input,.pl-field select,.pl-field textarea{border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:#fff;outline:none;width:100%;box-sizing:border-box}
// .pl-field input:focus,.pl-field select:focus,.pl-field textarea:focus{border-color:#ea580c}
// .pl-count{font-size:11px;color:#94a3b8;text-align:right}
// .pl-chips{display:flex;flex-wrap:wrap;gap:8px}
// .pl-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid #cbd5e1;border-radius:999px;font-size:13px;cursor:pointer;background:#fff;user-select:none}
// .pl-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
// .pl-chip input{display:none}
// .pl-toggles{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:10px}
// .pl-inline{display:flex;gap:8px;margin-top:12px}
// .pl-inline input{flex:1;border:1px solid #cbd5e1;border-radius:10px;padding:9px 12px;font-size:14px}
// .pl-drop{display:flex;align-items:center;gap:12px;padding:16px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc;cursor:pointer}
// .pl-drop:hover{border-color:#ea580c;background:#fff7f2}
// .pl-drop input{display:none}
// .pl-drop-icon{width:40px;height:40px;border-radius:10px;background:#fff1e8;color:#ea580c;display:grid;place-items:center;font-size:20px;font-weight:700}
// .pl-drop small{display:block;color:#64748b;font-size:12px;margin-top:2px}
// .pl-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-top:14px}
// .pl-img{position:relative;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff}
// .pl-img img{width:100%;height:110px;object-fit:cover;display:block}
// .pl-img-bar{display:flex;gap:6px;padding:8px;flex-wrap:wrap}
// .pl-cover-tag{position:absolute;top:8px;left:8px;background:#ea580c;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
// .pl-new-tag{position:absolute;top:8px;left:8px;background:#0f172a;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
// .pl-footer{display:flex;justify-content:flex-end;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0}
// .pl-loading{padding:50px;text-align:center;color:#64748b}
// @media(max-width:700px){.pl-fields{grid-template-columns:1fr}}
// `;

// /* =====================================================
//    SMALL UI PIECES
// ===================================================== */

// function Field({ label, value, onChange, type = "text", placeholder = "", maxLength, full = false, min, max, step }) {
//   return (
//     <div className={full ? "pl-field full" : "pl-field"}>
//       <label>{label}</label>
//       <input
//         type={type}
//         value={value}
//         placeholder={placeholder}
//         maxLength={maxLength}
//         min={min}
//         max={max}
//         step={step}
//         onChange={(e) => onChange(e.target.value)}
//       />
//     </div>
//   );
// }

// function Area({ label, value, onChange, maxLength, rows = 3, placeholder = "" }) {
//   return (
//     <div className="pl-field full">
//       <label>{label}</label>
//       <textarea
//         rows={rows}
//         value={value}
//         maxLength={maxLength}
//         placeholder={placeholder}
//         onChange={(e) => onChange(e.target.value)}
//       />
//       {maxLength ? <div className="pl-count">{value.length}/{maxLength}</div> : null}
//     </div>
//   );
// }

// function Toggle({ label, checked, onChange }) {
//   return (
//     <label className={checked ? "pl-chip on" : "pl-chip"}>
//       <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
//       {checked ? "✓ " : ""}{label}
//     </label>
//   );
// }

// /* =====================================================
//    PALACE FORM  (create + edit)
// ===================================================== */

// function PalaceForm({ palace, onCancel, onSaved, onPalaceChanged }) {
//   const isEdit = Boolean(palace);

//   const [form, setForm] = useState(() => (palace ? formFromPalace(palace) : EMPTY_FORM));
//   const [newFiles, setNewFiles] = useState([]); // [{ file, preview }]
//   const [customAmenity, setCustomAmenity] = useState("");
//   const [saving, setSaving] = useState(false);
//   const [busyImage, setBusyImage] = useState("");
//   const [error, setError] = useState("");

//   const existingImages = palace?.images || [];
//   const coverPublicId = palace?.coverImage?.publicId || "";

//   // free blob URLs on unmount
//   useEffect(
//     () => () => newFiles.forEach((f) => URL.revokeObjectURL(f.preview)),
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     []
//   );

//   const set = (name, value) => {
//     setForm((prev) => ({ ...prev, [name]: value }));
//     setError("");
//   };

//   const setPolicy = (name, value) => {
//     setForm((prev) => ({ ...prev, policies: { ...prev.policies, [name]: value } }));
//     setError("");
//   };

//   const toggleAmenity = (name) =>
//     setForm((prev) => ({
//       ...prev,
//       amenities: prev.amenities.includes(name)
//         ? prev.amenities.filter((a) => a !== name)
//         : [...prev.amenities, name],
//     }));

//   const addCustomAmenity = () => {
//     const value = customAmenity.trim();
//     if (!value) return;

//     if (form.amenities.some((a) => a.toLowerCase() === value.toLowerCase())) {
//       setError(`"${value}" is already added.`);
//       return;
//     }

//     setForm((prev) => ({ ...prev, amenities: [...prev.amenities, value] }));
//     setCustomAmenity("");
//     setError("");
//   };

//   const pickFiles = (event) => {
//     const picked = [];
//     let problem = "";

//     Array.from(event.target.files || []).forEach((file) => {
//       if (!file.type.startsWith("image/")) {
//         problem = `${file.name}: only image files are allowed.`;
//         return;
//       }
//       if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
//         problem = `${file.name} is larger than ${MAX_IMAGE_MB} MB.`;
//         return;
//       }
//       picked.push({ file, preview: URL.createObjectURL(file) });
//     });

//     event.target.value = "";

//     if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
//       picked.forEach((p) => URL.revokeObjectURL(p.preview));
//       setError(`A maximum of ${MAX_IMAGES} images is allowed.`);
//       return;
//     }

//     setError(problem);
//     if (picked.length) setNewFiles((prev) => [...prev, ...picked]);
//   };

//   const removeNewFile = (index) => {
//     URL.revokeObjectURL(newFiles[index].preview);
//     setNewFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   /* ---------- existing gallery actions ---------- */

//   const makeCover = async (publicId) => {
//     setBusyImage(publicId);
//     setError("");

//     try {
//       const data = await request(`${API}/${palace._id}/cover`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ publicId }),
//       });
//       onPalaceChanged(data.data);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyImage("");
//     }
//   };

//   const removeExisting = async (publicId) => {
//     if (!window.confirm("Delete this image permanently?")) return;

//     setBusyImage(publicId);
//     setError("");

//     try {
//       const data = await request(`${API}/${palace._id}/images`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ publicId }),
//       });
//       onPalaceChanged(data.data);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyImage("");
//     }
//   };

//   /* ---------- submit ---------- */

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     const problem = validateForm(form, existingImages.length + newFiles.length);
//     if (problem) {
//       setError(problem);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//       return;
//     }

//     const body = new FormData();

//     body.append("propertyName", form.propertyName.trim());
//     body.append("propertyType", form.propertyType);
//     body.append("shortDescription", form.shortDescription);
//     body.append("description", form.description);
//     body.append("starRating", form.starRating);

//     body.append("phone", form.phone.trim());
//     body.append("alternatePhone", form.alternatePhone.trim());
//     body.append("email", form.email.trim());

//     body.append("addressLine", form.addressLine);
//     body.append("landmark", form.landmark);
//     body.append("city", form.city.trim());
//     body.append("state", form.state.trim());
//     body.append("country", form.country.trim() || "India");
//     body.append("pincode", form.pincode.trim());
//     body.append("latitude", form.latitude);
//     body.append("longitude", form.longitude);

//     body.append("totalRooms", form.totalRooms || "0");
//     body.append("heritageCertified", String(form.heritageCertified));
//     body.append("weddingAllowed", String(form.weddingAllowed));
//     body.append("eventAllowed", String(form.eventAllowed));

//     body.append("checkInTime", form.checkInTime);
//     body.append("checkOutTime", form.checkOutTime);

//     // backend parseJSON() expects JSON strings for these two
//     body.append("amenities", JSON.stringify(form.amenities.map((a) => a.trim())));
//     body.append("policies", JSON.stringify(form.policies));

//     // backend: upload.array("images", 30)
//     newFiles.forEach((item) => body.append("images", item.file));

//     setSaving(true);
//     setError("");

//     try {
//       const data = await request(isEdit ? `${API}/${palace._id}` : API, {
//         method: isEdit ? "PUT" : "POST",
//         body, // no Content-Type: browser sets multipart boundary
//       });

//       newFiles.forEach((f) => URL.revokeObjectURL(f.preview));
//       onSaved(
//         data.data,
//         isEdit ? "Palace updated successfully." : "Palace created and is now live."
//       );
//     } catch (err) {
//       setError(err.message);
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ---------- render ---------- */

//   return (
//     <form className="pl-form" onSubmit={handleSubmit} noValidate>
//       {error && <div className="pl-alert pl-err">{error}</div>}

//       {/* BASIC */}
//       <section className="pl-section">
//         <h3>Basic information</h3>
//         <div className="pl-fields">
//           <Field label="Property name *" value={form.propertyName} onChange={(v) => set("propertyName", v)} maxLength={150} placeholder="e.g. Rambagh Heritage Palace" full />

//           <div className="pl-field">
//             <label>Property type</label>
//             <select value={form.propertyType} onChange={(e) => set("propertyType", e.target.value)}>
//               {PROPERTY_TYPES.map(([id, name]) => (
//                 <option key={id} value={id}>{name}</option>
//               ))}
//             </select>
//           </div>

//           <div className="pl-field">
//             <label>Star rating (1-5)</label>
//             <select value={form.starRating} onChange={(e) => set("starRating", e.target.value)}>
//               {[1, 2, 3, 4, 5].map((n) => (
//                 <option key={n} value={n}>{n} Star</option>
//               ))}
//             </select>
//           </div>

//           <Area label="Short description" value={form.shortDescription} onChange={(v) => set("shortDescription", v)} maxLength={300} rows={2} placeholder="One or two lines shown in listings" />
//           <Area label="Full description" value={form.description} onChange={(v) => set("description", v)} maxLength={10000} rows={6} placeholder="History, rooms, experiences, dining..." />
//         </div>
//       </section>

//       {/* CONTACT */}
//       <section className="pl-section">
//         <h3>Contact</h3>
//         <div className="pl-fields">
//           <Field label="Phone" value={form.phone} onChange={(v) => set("phone", v)} maxLength={20} placeholder="+91..." />
//           <Field label="Alternate phone" value={form.alternatePhone} onChange={(v) => set("alternatePhone", v)} maxLength={20} />
//           <Field label="Contact email" type="email" value={form.email} onChange={(v) => set("email", v)} maxLength={254} placeholder="palace@example.com" full />
//         </div>
//       </section>

//       {/* LOCATION */}
//       <section className="pl-section">
//         <h3>Location</h3>
//         <div className="pl-fields">
//           <Field label="Address" value={form.addressLine} onChange={(v) => set("addressLine", v)} maxLength={300} full />
//           <Field label="Landmark" value={form.landmark} onChange={(v) => set("landmark", v)} maxLength={200} />
//           <Field label="City" value={form.city} onChange={(v) => set("city", v)} maxLength={100} />
//           <Field label="State" value={form.state} onChange={(v) => set("state", v)} maxLength={100} />
//           <Field label="Country" value={form.country} onChange={(v) => set("country", v)} maxLength={100} />
//           <Field label="Pincode" value={form.pincode} onChange={(v) => set("pincode", v)} maxLength={15} />
//           <Field label="Latitude" type="number" step="any" value={form.latitude} onChange={(v) => set("latitude", v)} placeholder="e.g. 26.9124" />
//           <Field label="Longitude" type="number" step="any" value={form.longitude} onChange={(v) => set("longitude", v)} placeholder="e.g. 75.7873" />
//         </div>
//       </section>

//       {/* PROPERTY DETAILS */}
//       <section className="pl-section">
//         <h3>Property details</h3>
//         <div className="pl-fields">
//           <Field label="Total rooms" type="number" min="0" step="1" value={form.totalRooms} onChange={(v) => set("totalRooms", v)} />
//           <div className="pl-field" />
//           <Field label="Check-in time" type="time" value={form.checkInTime} onChange={(v) => set("checkInTime", v)} />
//           <Field label="Check-out time" type="time" value={form.checkOutTime} onChange={(v) => set("checkOutTime", v)} />
//         </div>

//         <div className="pl-toggles" style={{ marginTop: 16 }}>
//           <Toggle label="Heritage certified" checked={form.heritageCertified} onChange={(v) => set("heritageCertified", v)} />
//           <Toggle label="Weddings allowed" checked={form.weddingAllowed} onChange={(v) => set("weddingAllowed", v)} />
//           <Toggle label="Events allowed" checked={form.eventAllowed} onChange={(v) => set("eventAllowed", v)} />
//         </div>
//       </section>

//       {/* AMENITIES */}
//       <section className="pl-section">
//         <h3>Amenities</h3>
//         <div className="pl-chips">
//           {AMENITY_OPTIONS.map((name) => (
//             <Toggle key={name} label={name} checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
//           ))}

//           {form.amenities
//             .filter((a) => !AMENITY_OPTIONS.includes(a))
//             .map((name) => (
//               <Toggle key={name} label={name} checked onChange={() => toggleAmenity(name)} />
//             ))}
//         </div>

//         <div className="pl-inline">
//           <input
//             value={customAmenity}
//             maxLength={100}
//             placeholder="Add other amenity"
//             onChange={(e) => setCustomAmenity(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 e.preventDefault();
//                 addCustomAmenity();
//               }
//             }}
//           />
//           <button type="button" className="pl-btn pl-ghost" onClick={addCustomAmenity}>Add</button>
//         </div>
//       </section>

//       {/* POLICIES */}
//       <section className="pl-section">
//         <h3>Policies</h3>
//         <div className="pl-fields">
//           <Area label="Cancellation policy" value={form.policies.cancellationPolicy} onChange={(v) => setPolicy("cancellationPolicy", v)} maxLength={3000} />
//           <Area label="Child policy" value={form.policies.childPolicy} onChange={(v) => setPolicy("childPolicy", v)} maxLength={3000} />
//           <Area label="Pet policy" value={form.policies.petPolicy} onChange={(v) => setPolicy("petPolicy", v)} maxLength={3000} />
//           <Area label="Smoking policy" value={form.policies.smokingPolicy} onChange={(v) => setPolicy("smokingPolicy", v)} maxLength={3000} />
//         </div>

//         <div className="pl-toggles" style={{ marginTop: 16 }}>
//           <Toggle label="Unmarried couples allowed" checked={form.policies.unmarriedCouplesAllowed} onChange={(v) => setPolicy("unmarriedCouplesAllowed", v)} />
//           <Toggle label="Local ID allowed" checked={form.policies.localIdAllowed} onChange={(v) => setPolicy("localIdAllowed", v)} />
//           <Toggle label="ID proof required" checked={form.policies.idProofRequired} onChange={(v) => setPolicy("idProofRequired", v)} />
//         </div>
//       </section>

//       {/* GALLERY */}
//       <section className="pl-section">
//         <h3>
//           Gallery ({existingImages.length + newFiles.length}/{MAX_IMAGES})
//         </h3>

//         <label className="pl-drop">
//           <input type="file" accept="image/*" multiple onChange={pickFiles} />
//           <span className="pl-drop-icon">+</span>
//           <span>
//             <strong>Upload palace images</strong>
//             <small>JPG, PNG, WEBP · max {MAX_IMAGE_MB} MB each · first image becomes the cover</small>
//           </span>
//         </label>

//         {(existingImages.length > 0 || newFiles.length > 0) && (
//           <div className="pl-images">
//             {existingImages.map((img) => {
//               const isCover = img.publicId === coverPublicId;
//               const busy = busyImage === img.publicId;

//               return (
//                 <div className="pl-img" key={img.publicId || img.url}>
//                   <img src={img.url} alt="Palace" />
//                   {isCover && <span className="pl-cover-tag">COVER</span>}

//                   <div className="pl-img-bar">
//                     {!isCover && (
//                       <button type="button" className="pl-btn pl-ghost pl-small" disabled={busy} onClick={() => makeCover(img.publicId)}>
//                         Set cover
//                       </button>
//                     )}
//                     <button type="button" className="pl-btn pl-danger pl-small" disabled={busy} onClick={() => removeExisting(img.publicId)}>
//                       {busy ? "..." : "Delete"}
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}

//             {newFiles.map((item, index) => (
//               <div className="pl-img" key={`${item.file.name}-${index}`}>
//                 <img src={item.preview} alt={item.file.name} />
//                 <span className="pl-new-tag">NEW</span>
//                 <div className="pl-img-bar">
//                   <button type="button" className="pl-btn pl-danger pl-small" onClick={() => removeNewFile(index)}>
//                     Remove
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </section>

//       <div className="pl-footer">
//         <button type="button" className="pl-btn pl-ghost" onClick={onCancel} disabled={saving}>
//           Cancel
//         </button>
//         <button type="submit" className="pl-btn pl-primary" disabled={saving}>
//           {saving ? "Saving..." : isEdit ? "Save changes" : "Create palace"}
//         </button>
//       </div>
//     </form>
//   );
// }

// /* =====================================================
//    MAIN PAGE
// ===================================================== */

// export default function AddPlace() {
//   const [palaces, setPalaces] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [view, setView] = useState("list"); // "list" | "form"
//   const [editing, setEditing] = useState(null);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [busyId, setBusyId] = useState("");

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const data = await request(API);
//       setPalaces(Array.isArray(data.data) ? data.data : []);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const replaceInList = (updated) =>
//     setPalaces((prev) => prev.map((p) => (p._id === updated._id ? updated : p)));

//   const openCreate = () => {
//     setEditing(null);
//     setSuccess("");
//     setError("");
//     setView("form");
//   };

//   const openEdit = (palace) => {
//     setEditing(palace);
//     setSuccess("");
//     setError("");
//     setView("form");
//   };

//   const closeForm = () => {
//     setView("list");
//     setEditing(null);
//   };

//   const handleSaved = (saved, message) => {
//     setPalaces((prev) =>
//       prev.some((p) => p._id === saved._id)
//         ? prev.map((p) => (p._id === saved._id ? saved : p))
//         : [saved, ...prev]
//     );
//     setSuccess(message);
//     closeForm();
//   };

//   // image set-cover / delete inside the form
//   const handlePalaceChanged = (updated) => {
//     setEditing(updated);
//     replaceInList(updated);
//   };

//   const handleToggle = async (palace) => {
//     setBusyId(palace._id);
//     setError("");
//     setSuccess("");

//     try {
//       const data = await request(`${API}/${palace._id}/toggle`, { method: "PATCH" });
//       replaceInList(data.data);
//       setSuccess(data.message || "Status updated.");
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyId("");
//     }
//   };

//   const handleDelete = async (palace) => {
//     if (!window.confirm(`Delete "${palace.propertyName}" and all its images? This cannot be undone.`)) {
//       return;
//     }

//     setBusyId(palace._id);
//     setError("");
//     setSuccess("");

//     try {
//       const data = await request(`${API}/${palace._id}`, { method: "DELETE" });
//       setPalaces((prev) => prev.filter((p) => p._id !== palace._id));
//       setSuccess(data.message || "Palace deleted.");
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyId("");
//     }
//   };

//   /* ---------- FORM VIEW ---------- */

//   if (view === "form") {
//     return (
//       <div className="pl-wrap">
//         <style>{css}</style>

//         <div className="pl-head">
//           <div>
//             <h2>{editing ? "Edit palace" : "Add palace"}</h2>
//             <p>
//               {editing
//                 ? "Update details, manage gallery images and choose the cover photo."
//                 : "Fill in the palace details. It goes live immediately after saving."}
//             </p>
//           </div>
//         </div>

//         <PalaceForm
//           key={editing?._id || "new"}
//           palace={editing}
//           onCancel={closeForm}
//           onSaved={handleSaved}
//           onPalaceChanged={handlePalaceChanged}
//         />
//       </div>
//     );
//   }

//   /* ---------- LIST VIEW ---------- */

//   return (
//     <div className="pl-wrap">
//       <style>{css}</style>

//       <div className="pl-head">
//         <div>
//           <h2>My palaces</h2>
//           <p>Create and manage your palace and heritage properties.</p>
//         </div>
//         <button type="button" className="pl-btn pl-primary" onClick={openCreate}>
//           + Add palace
//         </button>
//       </div>

//       {success && <div className="pl-alert pl-ok">{success}</div>}
//       {error && <div className="pl-alert pl-err">{error}</div>}

//       {loading ? (
//         <div className="pl-loading">Loading palaces...</div>
//       ) : palaces.length === 0 ? (
//         <div className="pl-empty">
//           <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No palaces yet</h3>
//           <p style={{ margin: "0 0 16px" }}>Add your first palace to start receiving bookings.</p>
//           <button type="button" className="pl-btn pl-primary" onClick={openCreate}>
//             + Add palace
//           </button>
//         </div>
//       ) : (
//         <div className="pl-grid">
//           {palaces.map((palace) => {
//             const [label, color, bg] = STATUS_STYLE[palace.status] || STATUS_STYLE.APPROVED;
//             const busy = busyId === palace._id;
//             const place = [palace.address?.city, palace.address?.state].filter(Boolean).join(", ");

//             return (
//               <article className="pl-card" key={palace._id}>
//                 <div className="pl-cover">
//                   {palace.coverImage?.url ? (
//                     <img src={palace.coverImage.url} alt={palace.propertyName} />
//                   ) : (
//                     <span>No cover image</span>
//                   )}
//                   <span className="pl-badge" style={{ color, background: bg }}>{label}</span>
//                 </div>

//                 <div className="pl-body">
//                   <h3>{palace.propertyName}</h3>
//                   <div className="pl-meta">
//                     {PROPERTY_TYPES.find(([id]) => id === palace.propertyType)?.[1] || palace.propertyType}
//                     {" · "}
//                     {palace.starRating} Star
//                   </div>
//                   {place && <div className="pl-meta">{place}</div>}
//                   <div className="pl-meta">
//                     {palace.totalRooms || 0} rooms · {palace.images?.length || 0} images
//                   </div>

//                   <div className="pl-actions">
//                     <button type="button" className="pl-btn pl-ghost pl-small" onClick={() => openEdit(palace)} disabled={busy}>
//                       Edit
//                     </button>

//                     <button type="button" className="pl-btn pl-ghost pl-small" onClick={() => handleToggle(palace)} disabled={busy}>
//                       {busy ? "..." : palace.status === "INACTIVE" ? "Activate" : "Deactivate"}
//                     </button>

//                     <button type="button" className="pl-btn pl-danger pl-small" onClick={() => handleDelete(palace)} disabled={busy}>
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               </article>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }







import { useCallback, useEffect, useState } from "react";

/* =====================================================
   API  (backend: /api/palaces  -> palaceRoutes.js)
===================================================== */

const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";
const API = `${API_BASE}/api/palaces`;

async function request(url, options = {}) {
  const token = localStorage.getItem("vendorToken");

  if (!token) {
    window.location.href = "/vendor-login";
    throw new Error("Session expired. Please login again.");
  }

  const response = await fetch(url, {
    ...options,
    headers: { Authorization: `Bearer ${token}`, ...(options.headers || {}) },
  });

  const data = await response.json().catch(() => ({}));

  if (response.status === 401) {
    localStorage.removeItem("vendorToken");
    localStorage.removeItem("vendorUser");
    window.location.href = "/vendor-login";
    throw new Error("Session expired. Please login again.");
  }

  if (!response.ok || data.success === false) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }

  return data;
}

/* =====================================================
   OPTIONS / DEFAULTS
===================================================== */

const PROPERTY_TYPES = [
  ["heritage-palace", "Heritage Palace"],
  ["luxury-palace", "Luxury Palace"],
  ["royal-palace", "Royal Palace"],
  ["heritage-hotel", "Heritage Hotel"],
  ["fort-palace", "Fort Palace"],
  ["other", "Other"],
];

const AMENITY_OPTIONS = [
  "Free Wi-Fi", "Parking", "Air Conditioning", "Restaurant", "Room Service",
  "Swimming Pool", "Spa", "Gym", "Airport Transfer", "24x7 Front Desk",
  "Power Backup", "Lift / Elevator", "Laundry", "Banquet Hall", "Garden / Lawn",
  "Heritage Tour", "Cultural Shows", "Wheelchair Accessible",
];

// No approval flow: a palace is either Live or Inactive
const STATUS_STYLE = {
  APPROVED: ["Live", "#166534", "#dcfce7"],
  INACTIVE: ["Inactive", "#334155", "#f1f5f9"],
};

const MAX_IMAGES = 30;
const MAX_IMAGE_MB = 10;

const EMPTY_FORM = {
  propertyName: "",
  propertyType: "heritage-palace",
  shortDescription: "",
  description: "",
  starRating: "3",

  phone: "",
  alternatePhone: "",
  email: "",

  addressLine: "",
  landmark: "",
  city: "",
  state: "",
  country: "India",
  pincode: "",
  latitude: "",
  longitude: "",

  totalRooms: "0",
  heritageCertified: false,
  weddingAllowed: false,
  eventAllowed: false,

  checkInTime: "14:00",
  checkOutTime: "11:00",

  amenities: [],

  policies: {
    cancellationPolicy: "",
    childPolicy: "",
    petPolicy: "",
    smokingPolicy: "",
    unmarriedCouplesAllowed: false,
    localIdAllowed: false,
    idProofRequired: true,
  },
};

const str = (v) => (v === undefined || v === null ? "" : String(v));

function formFromPalace(p) {
  return {
    propertyName: str(p.propertyName),
    propertyType: p.propertyType || "heritage-palace",
    shortDescription: str(p.shortDescription),
    description: str(p.description),
    starRating: str(p.starRating ?? 3),

    phone: str(p.contact?.phone),
    alternatePhone: str(p.contact?.alternatePhone),
    email: str(p.contact?.email),

    addressLine: str(p.address?.addressLine),
    landmark: str(p.address?.landmark),
    city: str(p.address?.city),
    state: str(p.address?.state),
    country: str(p.address?.country || "India"),
    pincode: str(p.address?.pincode),
    latitude: str(p.address?.latitude),
    longitude: str(p.address?.longitude),

    totalRooms: str(p.totalRooms ?? 0),
    heritageCertified: Boolean(p.heritageCertified),
    weddingAllowed: Boolean(p.weddingAllowed),
    eventAllowed: Boolean(p.eventAllowed),

    checkInTime: p.checkInTime || "14:00",
    checkOutTime: p.checkOutTime || "11:00",

    amenities: Array.isArray(p.amenities) ? p.amenities : [],

    policies: {
      ...EMPTY_FORM.policies,
      ...(p.policies || {}),
    },
  };
}

/* =====================================================
   VALIDATION  (same rules as palaceModel.js)
===================================================== */

function validateForm(form, imageCount) {
  const name = form.propertyName.trim();

  if (!name) return "Property name is required.";
  if (name.length < 2) return "Property name must be at least 2 characters.";

  const star = Number(form.starRating);
  if (!Number.isFinite(star) || star < 1 || star > 5) {
    return "Star rating must be between 1 and 5.";
  }

  if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
    return "Please enter a valid contact email.";
  }

  const rooms = Number(form.totalRooms || 0);
  if (!Number.isInteger(rooms) || rooms < 0) {
    return "Total rooms must be a whole number (0 or more).";
  }

  if (form.latitude !== "") {
    const lat = Number(form.latitude);
    if (!Number.isFinite(lat) || lat < -90 || lat > 90) {
      return "Latitude must be between -90 and 90.";
    }
  }

  if (form.longitude !== "") {
    const lng = Number(form.longitude);
    if (!Number.isFinite(lng) || lng < -180 || lng > 180) {
      return "Longitude must be between -180 and 180.";
    }
  }

  if (!form.checkInTime || !form.checkOutTime) {
    return "Check-in and check-out time are required.";
  }

  const lower = form.amenities.map((a) => a.trim().toLowerCase());
  if (lower.some((a) => !a) || new Set(lower).size !== lower.length) {
    return "Amenities cannot be empty or duplicated.";
  }

  if (imageCount > MAX_IMAGES) {
    return `A maximum of ${MAX_IMAGES} images is allowed.`;
  }

  return "";
}

/* =====================================================
   STYLES (scoped with "pl-" prefix)
===================================================== */

const css = `
.pl-wrap{font-family:'Inter','Segoe UI',Arial,sans-serif;color:#0f172a}
.pl-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:22px}
.pl-head h2{margin:0 0 4px;font-size:26px;letter-spacing:-.5px}
.pl-head p{margin:0;color:#64748b;font-size:14px}
.pl-btn{border:0;border-radius:10px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;transition:.15s}
.pl-btn:disabled{opacity:.6;cursor:not-allowed}
.pl-primary{background:linear-gradient(135deg,#f97316,#ea580c);color:#fff}
.pl-ghost{background:#fff;border:1px solid #cbd5e1;color:#0f172a}
.pl-danger{background:#fff;border:1px solid #fecaca;color:#b91c1c}
.pl-small{padding:7px 12px;font-size:12px}
.pl-alert{padding:12px 14px;border-radius:10px;margin-bottom:16px;font-size:13px}
.pl-err{background:#fff7ed;border:1px solid #fed7aa;color:#9a3412}
.pl-ok{background:#f0fdf4;border:1px solid #bbf7d0;color:#166534}
.pl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:18px}
.pl-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;overflow:hidden;display:flex;flex-direction:column}
.pl-cover{height:170px;background:#f1f5f9;display:grid;place-items:center;color:#94a3b8;font-size:13px;position:relative}
.pl-cover img{width:100%;height:100%;object-fit:cover;display:block}
.pl-badge{position:absolute;top:10px;left:10px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:800}
.pl-body{padding:16px;display:flex;flex-direction:column;gap:6px;flex:1}
.pl-body h3{margin:0;font-size:17px}
.pl-meta{font-size:12px;color:#64748b}
.pl-actions{display:flex;gap:8px;flex-wrap:wrap;margin-top:auto;padding-top:12px}
.pl-empty{background:#fff;border:1px dashed #cbd5e1;border-radius:16px;padding:48px 20px;text-align:center;color:#64748b}
.pl-form{display:flex;flex-direction:column;gap:18px}
.pl-section{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:20px}
.pl-section h3{margin:0 0 14px;font-size:16px}
.pl-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
.pl-field{display:flex;flex-direction:column;gap:6px}
.pl-field.full{grid-column:1/-1}
.pl-field label{font-size:12px;font-weight:700;color:#374151}
.pl-field input,.pl-field select,.pl-field textarea{border:1px solid #cbd5e1;border-radius:10px;padding:10px 12px;font-size:14px;font-family:inherit;color:#0f172a;background:#fff;outline:none;width:100%;box-sizing:border-box}
.pl-field input:focus,.pl-field select:focus,.pl-field textarea:focus{border-color:#ea580c}
.pl-count{font-size:11px;color:#94a3b8;text-align:right}
.pl-chips{display:flex;flex-wrap:wrap;gap:8px}
.pl-chip{display:inline-flex;align-items:center;gap:6px;padding:7px 12px;border:1px solid #cbd5e1;border-radius:999px;font-size:13px;cursor:pointer;background:#fff;user-select:none}
.pl-chip.on{background:#fff1e8;border-color:#ea580c;color:#c2410c;font-weight:700}
.pl-chip input{display:none}
.pl-toggles{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:10px}
.pl-inline{display:flex;gap:8px;margin-top:12px}
.pl-inline input{flex:1;border:1px solid #cbd5e1;border-radius:10px;padding:9px 12px;font-size:14px}
.pl-drop{display:flex;align-items:center;gap:12px;padding:16px;border:1.5px dashed #cbd5e1;border-radius:12px;background:#f8fafc;cursor:pointer}
.pl-drop:hover{border-color:#ea580c;background:#fff7f2}
.pl-drop input{display:none}
.pl-drop-icon{width:40px;height:40px;border-radius:10px;background:#fff1e8;color:#ea580c;display:grid;place-items:center;font-size:20px;font-weight:700}
.pl-drop small{display:block;color:#64748b;font-size:12px;margin-top:2px}
.pl-images{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-top:14px}
.pl-img{position:relative;border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;background:#fff}
.pl-img img{width:100%;height:110px;object-fit:cover;display:block}
.pl-img-bar{display:flex;gap:6px;padding:8px;flex-wrap:wrap}
.pl-cover-tag{position:absolute;top:8px;left:8px;background:#ea580c;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
.pl-new-tag{position:absolute;top:8px;left:8px;background:#0f172a;color:#fff;font-size:10px;font-weight:800;padding:3px 8px;border-radius:999px}
.pl-footer{display:flex;justify-content:flex-end;gap:10px;position:sticky;bottom:0;background:#f8fafc;padding:14px 0;border-top:1px solid #e2e8f0}
.pl-loading{padding:50px;text-align:center;color:#64748b}
@media(max-width:700px){.pl-fields{grid-template-columns:1fr}}
`;

/* =====================================================
   SMALL UI PIECES
===================================================== */

function Field({ label, value, onChange, type = "text", placeholder = "", maxLength, full = false, min, max, step }) {
  return (
    <div className={full ? "pl-field full" : "pl-field"}>
      <label>{label}</label>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function Area({ label, value, onChange, maxLength, rows = 3, placeholder = "" }) {
  return (
    <div className="pl-field full">
      <label>{label}</label>
      <textarea
        rows={rows}
        value={value}
        maxLength={maxLength}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      {maxLength ? <div className="pl-count">{value.length}/{maxLength}</div> : null}
    </div>
  );
}

function Toggle({ label, checked, onChange }) {
  return (
    <label className={checked ? "pl-chip on" : "pl-chip"}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      {checked ? "✓ " : ""}{label}
    </label>
  );
}

/* =====================================================
   PALACE FORM  (create + edit)
===================================================== */

function PalaceForm({ palace, onCancel, onSaved, onPalaceChanged }) {
  const isEdit = Boolean(palace);

  const [form, setForm] = useState(() => (palace ? formFromPalace(palace) : EMPTY_FORM));
  const [newFiles, setNewFiles] = useState([]); // [{ file, preview }]
  const [customAmenity, setCustomAmenity] = useState("");
  const [saving, setSaving] = useState(false);
  const [busyImage, setBusyImage] = useState("");
  const [error, setError] = useState("");

  const existingImages = palace?.images || [];
  const coverPublicId = palace?.coverImage?.publicId || "";

  // free blob URLs on unmount
  useEffect(
    () => () => newFiles.forEach((f) => URL.revokeObjectURL(f.preview)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const set = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const setPolicy = (name, value) => {
    setForm((prev) => ({ ...prev, policies: { ...prev.policies, [name]: value } }));
    setError("");
  };

  const toggleAmenity = (name) =>
    setForm((prev) => ({
      ...prev,
      amenities: prev.amenities.includes(name)
        ? prev.amenities.filter((a) => a !== name)
        : [...prev.amenities, name],
    }));

  const addCustomAmenity = () => {
    const value = customAmenity.trim();
    if (!value) return;

    if (form.amenities.some((a) => a.toLowerCase() === value.toLowerCase())) {
      setError(`"${value}" is already added.`);
      return;
    }

    setForm((prev) => ({ ...prev, amenities: [...prev.amenities, value] }));
    setCustomAmenity("");
    setError("");
  };

  const pickFiles = (event) => {
    const picked = [];
    let problem = "";

    Array.from(event.target.files || []).forEach((file) => {
      if (!file.type.startsWith("image/")) {
        problem = `${file.name}: only image files are allowed.`;
        return;
      }
      if (file.size > MAX_IMAGE_MB * 1024 * 1024) {
        problem = `${file.name} is larger than ${MAX_IMAGE_MB} MB.`;
        return;
      }
      picked.push({ file, preview: URL.createObjectURL(file) });
    });

    event.target.value = "";

    if (existingImages.length + newFiles.length + picked.length > MAX_IMAGES) {
      picked.forEach((p) => URL.revokeObjectURL(p.preview));
      setError(`A maximum of ${MAX_IMAGES} images is allowed.`);
      return;
    }

    setError(problem);
    if (picked.length) setNewFiles((prev) => [...prev, ...picked]);
  };

  const removeNewFile = (index) => {
    URL.revokeObjectURL(newFiles[index].preview);
    setNewFiles((prev) => prev.filter((_, i) => i !== index));
  };

  /* ---------- existing gallery actions ---------- */

  const makeCover = async (publicId) => {
    setBusyImage(publicId);
    setError("");

    try {
      const data = await request(`${API}/${palace._id}/cover`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ publicId }),
      });
      onPalaceChanged(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyImage("");
    }
  };

  const removeExisting = async (publicId) => {
    if (!window.confirm("Delete this image permanently?")) return;

    setBusyImage(publicId);
    setError("");

    try {
      const data = await request(`${API}/${palace._id}/images`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ publicId }),
      });
      onPalaceChanged(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyImage("");
    }
  };

  /* ---------- submit ---------- */

  const handleSubmit = async (event) => {
    event.preventDefault();

    const problem = validateForm(form, existingImages.length + newFiles.length);
    if (problem) {
      setError(problem);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const body = new FormData();

    body.append("propertyName", form.propertyName.trim());
    body.append("propertyType", form.propertyType);
    body.append("shortDescription", form.shortDescription);
    body.append("description", form.description);
    body.append("starRating", form.starRating);

    body.append("phone", form.phone.trim());
    body.append("alternatePhone", form.alternatePhone.trim());
    body.append("email", form.email.trim());

    body.append("addressLine", form.addressLine);
    body.append("landmark", form.landmark);
    body.append("city", form.city.trim());
    body.append("state", form.state.trim());
    body.append("country", form.country.trim() || "India");
    body.append("pincode", form.pincode.trim());
    body.append("latitude", form.latitude);
    body.append("longitude", form.longitude);

    body.append("heritageCertified", String(form.heritageCertified));
    body.append("weddingAllowed", String(form.weddingAllowed));
    body.append("eventAllowed", String(form.eventAllowed));

    body.append("checkInTime", form.checkInTime);
    body.append("checkOutTime", form.checkOutTime);

    // backend parseJSON() expects JSON strings for these two
    body.append("amenities", JSON.stringify(form.amenities.map((a) => a.trim())));
    body.append("policies", JSON.stringify(form.policies));

    // backend: upload.array("images", 30)
    newFiles.forEach((item) => body.append("images", item.file));

    setSaving(true);
    setError("");

    try {
      const data = await request(isEdit ? `${API}/${palace._id}` : API, {
        method: isEdit ? "PUT" : "POST",
        body, // no Content-Type: browser sets multipart boundary
      });

      newFiles.forEach((f) => URL.revokeObjectURL(f.preview));
      onSaved(
        data.data,
        isEdit ? "Palace updated successfully." : "Palace created and is now live."
      );
    } catch (err) {
      setError(err.message);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSaving(false);
    }
  };

  /* ---------- render ---------- */

  return (
    <form className="pl-form" onSubmit={handleSubmit} noValidate>
      {error && <div className="pl-alert pl-err">{error}</div>}

      {/* BASIC */}
      <section className="pl-section">
        <h3>Basic information</h3>
        <div className="pl-fields">
          <Field label="Property name *" value={form.propertyName} onChange={(v) => set("propertyName", v)} maxLength={150} placeholder="e.g. Rambagh Heritage Palace" full />

          <div className="pl-field">
            <label>Property type</label>
            <select value={form.propertyType} onChange={(e) => set("propertyType", e.target.value)}>
              {PROPERTY_TYPES.map(([id, name]) => (
                <option key={id} value={id}>{name}</option>
              ))}
            </select>
          </div>

          <div className="pl-field">
            <label>Star rating (1-5)</label>
            <select value={form.starRating} onChange={(e) => set("starRating", e.target.value)}>
              {[1, 2, 3, 4, 5].map((n) => (
                <option key={n} value={n}>{n} Star</option>
              ))}
            </select>
          </div>

          <Area label="Short description" value={form.shortDescription} onChange={(v) => set("shortDescription", v)} maxLength={300} rows={2} placeholder="One or two lines shown in listings" />
          <Area label="Full description" value={form.description} onChange={(v) => set("description", v)} maxLength={10000} rows={6} placeholder="History, rooms, experiences, dining..." />
        </div>
      </section>

      {/* CONTACT */}
      <section className="pl-section">
        <h3>Contact</h3>
        <div className="pl-fields">
          <Field label="Phone" value={form.phone} onChange={(v) => set("phone", v)} maxLength={20} placeholder="+91..." />
          <Field label="Alternate phone" value={form.alternatePhone} onChange={(v) => set("alternatePhone", v)} maxLength={20} />
          <Field label="Contact email" type="email" value={form.email} onChange={(v) => set("email", v)} maxLength={254} placeholder="palace@example.com" full />
        </div>
      </section>

      {/* LOCATION */}
      <section className="pl-section">
        <h3>Location</h3>
        <div className="pl-fields">
          <Field label="Address" value={form.addressLine} onChange={(v) => set("addressLine", v)} maxLength={300} full />
          <Field label="Landmark" value={form.landmark} onChange={(v) => set("landmark", v)} maxLength={200} />
          <Field label="City" value={form.city} onChange={(v) => set("city", v)} maxLength={100} />
          <Field label="State" value={form.state} onChange={(v) => set("state", v)} maxLength={100} />
          <Field label="Country" value={form.country} onChange={(v) => set("country", v)} maxLength={100} />
          <Field label="Pincode" value={form.pincode} onChange={(v) => set("pincode", v)} maxLength={15} />
          <Field label="Latitude" type="number" step="any" value={form.latitude} onChange={(v) => set("latitude", v)} placeholder="e.g. 26.9124" />
          <Field label="Longitude" type="number" step="any" value={form.longitude} onChange={(v) => set("longitude", v)} placeholder="e.g. 75.7873" />
        </div>
      </section>

      {/* PROPERTY DETAILS */}
      <section className="pl-section">
        <h3>Property details</h3>
        <div className="pl-fields">
          <div className="pl-field full">
            <label>Total rooms</label>
            <div style={{padding:"11px 12px",border:"1px solid #fed7aa",borderRadius:10,background:"#fff7ed",color:"#9a3412",fontSize:13}}>
              Total rooms are calculated automatically from this property's room categories. Save this palace first, then add its room categories.
            </div>
          </div>
          <Field label="Check-in time" type="time" value={form.checkInTime} onChange={(v) => set("checkInTime", v)} />
          <Field label="Check-out time" type="time" value={form.checkOutTime} onChange={(v) => set("checkOutTime", v)} />
        </div>

        <div className="pl-toggles" style={{ marginTop: 16 }}>
          <Toggle label="Heritage certified" checked={form.heritageCertified} onChange={(v) => set("heritageCertified", v)} />
          <Toggle label="Weddings allowed" checked={form.weddingAllowed} onChange={(v) => set("weddingAllowed", v)} />
          <Toggle label="Events allowed" checked={form.eventAllowed} onChange={(v) => set("eventAllowed", v)} />
        </div>
      </section>

      {/* AMENITIES */}
      <section className="pl-section">
        <h3>Amenities</h3>
        <div className="pl-chips">
          {AMENITY_OPTIONS.map((name) => (
            <Toggle key={name} label={name} checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
          ))}

          {form.amenities
            .filter((a) => !AMENITY_OPTIONS.includes(a))
            .map((name) => (
              <Toggle key={name} label={name} checked onChange={() => toggleAmenity(name)} />
            ))}
        </div>

        <div className="pl-inline">
          <input
            value={customAmenity}
            maxLength={100}
            placeholder="Add other amenity"
            onChange={(e) => setCustomAmenity(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addCustomAmenity();
              }
            }}
          />
          <button type="button" className="pl-btn pl-ghost" onClick={addCustomAmenity}>Add</button>
        </div>
      </section>

      {/* POLICIES */}
      <section className="pl-section">
        <h3>Policies</h3>
        <div className="pl-fields">
          <Area label="Cancellation policy" value={form.policies.cancellationPolicy} onChange={(v) => setPolicy("cancellationPolicy", v)} maxLength={3000} />
          <Area label="Child policy" value={form.policies.childPolicy} onChange={(v) => setPolicy("childPolicy", v)} maxLength={3000} />
          <Area label="Pet policy" value={form.policies.petPolicy} onChange={(v) => setPolicy("petPolicy", v)} maxLength={3000} />
          <Area label="Smoking policy" value={form.policies.smokingPolicy} onChange={(v) => setPolicy("smokingPolicy", v)} maxLength={3000} />
        </div>

        <div className="pl-toggles" style={{ marginTop: 16 }}>
          <Toggle label="Unmarried couples allowed" checked={form.policies.unmarriedCouplesAllowed} onChange={(v) => setPolicy("unmarriedCouplesAllowed", v)} />
          <Toggle label="Local ID allowed" checked={form.policies.localIdAllowed} onChange={(v) => setPolicy("localIdAllowed", v)} />
          <Toggle label="ID proof required" checked={form.policies.idProofRequired} onChange={(v) => setPolicy("idProofRequired", v)} />
        </div>
      </section>

      {/* GALLERY */}
      <section className="pl-section">
        <h3>
          Gallery ({existingImages.length + newFiles.length}/{MAX_IMAGES})
        </h3>

        <label className="pl-drop">
          <input type="file" accept="image/*" multiple onChange={pickFiles} />
          <span className="pl-drop-icon">+</span>
          <span>
            <strong>Upload palace images</strong>
            <small>JPG, PNG, WEBP · max {MAX_IMAGE_MB} MB each · first image becomes the cover</small>
          </span>
        </label>

        {(existingImages.length > 0 || newFiles.length > 0) && (
          <div className="pl-images">
            {existingImages.map((img) => {
              const isCover = img.publicId === coverPublicId;
              const busy = busyImage === img.publicId;

              return (
                <div className="pl-img" key={img.publicId || img.url}>
                  <img src={img.url} alt="Palace" />
                  {isCover && <span className="pl-cover-tag">COVER</span>}

                  <div className="pl-img-bar">
                    {!isCover && (
                      <button type="button" className="pl-btn pl-ghost pl-small" disabled={busy} onClick={() => makeCover(img.publicId)}>
                        Set cover
                      </button>
                    )}
                    <button type="button" className="pl-btn pl-danger pl-small" disabled={busy} onClick={() => removeExisting(img.publicId)}>
                      {busy ? "..." : "Delete"}
                    </button>
                  </div>
                </div>
              );
            })}

            {newFiles.map((item, index) => (
              <div className="pl-img" key={`${item.file.name}-${index}`}>
                <img src={item.preview} alt={item.file.name} />
                <span className="pl-new-tag">NEW</span>
                <div className="pl-img-bar">
                  <button type="button" className="pl-btn pl-danger pl-small" onClick={() => removeNewFile(index)}>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      <div className="pl-footer">
        <button type="button" className="pl-btn pl-ghost" onClick={onCancel} disabled={saving}>
          Cancel
        </button>
        <button type="submit" className="pl-btn pl-primary" disabled={saving}>
          {saving ? "Saving..." : isEdit ? "Save changes" : "Create palace"}
        </button>
      </div>
    </form>
  );
}

/* =====================================================
   MAIN PAGE
===================================================== */

export default function AddPlace() {
  const [palaces, setPalaces] = useState([]);
  const [roomStats, setRoomStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("list"); // "list" | "form"
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [busyId, setBusyId] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const data = await request(API);
      const palaceList = Array.isArray(data.data) ? data.data : [];
      setPalaces(palaceList);

      // Fetch categories independently for each palace, so counts never mix.
      const entries = await Promise.all(
        palaceList.map(async (palace) => {
          try {
            const result = await request(
              `${API_BASE}/api/palace-room-categories/palace/${palace._id}`
            );
            const categories = Array.isArray(result.data) ? result.data : [];
            return [
              palace._id,
              {
                categoryCount: categories.length,
                totalUnits: categories.reduce(
                  (sum, category) => sum + Number(category.totalUnits || 0),
                  0
                ),
              },
            ];
          } catch {
            return [
              palace._id,
              {
                categoryCount: 0,
                totalUnits: Number(palace.totalRooms || 0),
              },
            ];
          }
        })
      );
      setRoomStats(Object.fromEntries(entries));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const replaceInList = (updated) =>
    setPalaces((prev) => prev.map((p) => (p._id === updated._id ? updated : p)));

  const openCreate = () => {
    setEditing(null);
    setSuccess("");
    setError("");
    setView("form");
  };

  const openEdit = (palace) => {
    setEditing(palace);
    setSuccess("");
    setError("");
    setView("form");
  };

  const closeForm = () => {
    setView("list");
    setEditing(null);
  };

  const handleSaved = (saved, message) => {
    setPalaces((prev) =>
      prev.some((p) => p._id === saved._id)
        ? prev.map((p) => (p._id === saved._id ? saved : p))
        : [saved, ...prev]
    );
    setSuccess(message);
    closeForm();
  };

  // image set-cover / delete inside the form
  const handlePalaceChanged = (updated) => {
    setEditing(updated);
    replaceInList(updated);
  };

  const handleToggle = async (palace) => {
    setBusyId(palace._id);
    setError("");
    setSuccess("");

    try {
      const data = await request(`${API}/${palace._id}/toggle`, { method: "PATCH" });
      replaceInList(data.data);
      setSuccess(data.message || "Status updated.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId("");
    }
  };

  const handleDelete = async (palace) => {
    if (!window.confirm(`Delete "${palace.propertyName}" and all its images? This cannot be undone.`)) {
      return;
    }

    setBusyId(palace._id);
    setError("");
    setSuccess("");

    try {
      const data = await request(`${API}/${palace._id}`, { method: "DELETE" });
      setPalaces((prev) => prev.filter((p) => p._id !== palace._id));
      setSuccess(data.message || "Palace deleted.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId("");
    }
  };

  /* ---------- FORM VIEW ---------- */

  if (view === "form") {
    return (
      <div className="pl-wrap">
        <style>{css}</style>

        <div className="pl-head">
          <div>
            <h2>{editing ? "Edit palace" : "Add palace"}</h2>
            <p>
              {editing
                ? "Update details, manage gallery images and choose the cover photo."
                : "Fill in the palace details. It goes live immediately after saving."}
            </p>
          </div>
        </div>

        <PalaceForm
          key={editing?._id || "new"}
          palace={editing}
          onCancel={closeForm}
          onSaved={handleSaved}
          onPalaceChanged={handlePalaceChanged}
        />
      </div>
    );
  }

  /* ---------- LIST VIEW ---------- */

  return (
    <div className="pl-wrap">
      <style>{css}</style>

      <div className="pl-head">
        <div>
          <h2>My palaces</h2>
          <p>Create and manage your palace and heritage properties.</p>
        </div>
        <button type="button" className="pl-btn pl-primary" onClick={openCreate}>
          + Add palace
        </button>
      </div>

      {success && <div className="pl-alert pl-ok">{success}</div>}
      {error && <div className="pl-alert pl-err">{error}</div>}

      {loading ? (
        <div className="pl-loading">Loading palaces...</div>
      ) : palaces.length === 0 ? (
        <div className="pl-empty">
          <h3 style={{ margin: "0 0 6px", color: "#0f172a" }}>No palaces yet</h3>
          <p style={{ margin: "0 0 16px" }}>Add your first palace to start receiving bookings.</p>
          <button type="button" className="pl-btn pl-primary" onClick={openCreate}>
            + Add palace
          </button>
        </div>
      ) : (
        <div className="pl-grid">
          {palaces.map((palace) => {
            const [label, color, bg] = STATUS_STYLE[palace.status] || STATUS_STYLE.APPROVED;
            const busy = busyId === palace._id;
            const place = [palace.address?.city, palace.address?.state].filter(Boolean).join(", ");

            return (
              <article className="pl-card" key={palace._id}>
                <div className="pl-cover">
                  {palace.coverImage?.url ? (
                    <img src={palace.coverImage.url} alt={palace.propertyName} />
                  ) : (
                    <span>No cover image</span>
                  )}
                  <span className="pl-badge" style={{ color, background: bg }}>{label}</span>
                </div>

                <div className="pl-body">
                  <h3>{palace.propertyName}</h3>
                  <div className="pl-meta">
                    {PROPERTY_TYPES.find(([id]) => id === palace.propertyType)?.[1] || palace.propertyType}
                    {" · "}
                    {palace.starRating} Star
                  </div>
                  {place && <div className="pl-meta">{place}</div>}
                  <div className="pl-meta">
                    <strong>{roomStats[palace._id]?.totalUnits ?? palace.totalRooms ?? 0}</strong> total rooms
                    {" · "}
                    <strong>{roomStats[palace._id]?.categoryCount ?? 0}</strong> room categories
                    {" · "}
                    {palace.images?.length || 0} images
                  </div>
                  <div className="pl-meta">
                    Room counts shown here belong only to this property.
                  </div>

                  <div className="pl-actions">
                    <button type="button" className="pl-btn pl-ghost pl-small" onClick={() => openEdit(palace)} disabled={busy}>
                      Edit
                    </button>

                    <button type="button" className="pl-btn pl-ghost pl-small" onClick={() => handleToggle(palace)} disabled={busy}>
                      {busy ? "..." : palace.status === "INACTIVE" ? "Activate" : "Deactivate"}
                    </button>

                    <button type="button" className="pl-btn pl-danger pl-small" onClick={() => handleDelete(palace)} disabled={busy}>
                      Delete
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}